import round from "lodash/round";
import { format } from "numerable";

export const abbreviateNumber = (
  value: number,
  maximumFractionDigits = 1,
  minimumFractionDigits?: number,
): string =>
  Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits,
    minimumFractionDigits,
  }).format(value);

export const roundToDecimalPlace = (
  num: number,
  decimalPlaces: number,
): number => {
  return round(num, decimalPlaces);
};

export const commaNumber = (num: number, max = 100000000): string =>
  num < max ? format(num, "0,0") : abbreviateNumber(num);

export const accurateCommaNumber = (num: number | string): string =>
  format(num, "0,0.X", { rounding: "truncate" });

/** Formats a count like `accurateCommaNumber`, with a "~" prefix when the count is an estimate. */
export function formatCountWithEstimateMarker(
  count: number,
  isEstimate: boolean,
): string {
  return `${isEstimate ? "~" : ""}${accurateCommaNumber(count)}`;
}

export const truncateNumber = (num: number): string =>
  Number.isInteger(num) ? String(num) : format(num, "0.00");

export const ordinalSuffix = (num: number): string => {
  if (num > 3 && num < 21) return "th";

  switch (num % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};
